<template>
  <fade-transition>
    <span v-if="visible" :class="`color-error position-relative ${rowClass}`">
      <span
        :class="`border-radius-20 color-surface background-error font-size-11 width-${counterSize} height-${counterSize} flex-center position-absolute top--3 right--5 border--solid border--surface`"
      >
        {{ count }}
      </span>
      <mdicon :name="iconName" :size="iconSize" />
    </span>
  </fade-transition>
</template>

<script>
import { toRefs } from "vue";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    count: {
      type: [Number, String],
      default: null,
    },
    iconName: {
      type: String,
      default: "alert-circle-outline",
    },
    iconSize: {
      type: [Number, String],
      default: 24,
    },
    counterSize: {
      type: [Number, String],
      default: 16,
    },
    rowClass: {
      type: String,
      default: "",
    },
  },
  setup(props) {
    // generate props data
    const { visible, count, iconName, iconSize, counterSize } = toRefs(props);

    // return data to be used in template
    return { visible, count, iconName, iconSize, counterSize };
  },
};
</script>
